import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  width: '100%',
  spacing: 50,
})`
  height: 56px;
  padding: 0 21px;
  border: 1px solid #e9eaea;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: #fafafa;
`;

export const Content = styled(Flex).attrs({
  width: '100%',
})`
  border: 1px solid #e9eaea;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  table {
    width: 100%;
    padding: 21px;

    th {
      font-size: 12px;
      font-weight: 400;
      width: 40px;
      padding-bottom: 7px;
    }

    td {
      padding: 16px 0;
      border-bottom: 1px solid #ededed;
    }

    th,
    td {
      color: #757575;
      text-align: right;
      vertical-align: middle;

      &:first-child {
        width: 72%;
        text-align: left;
      }
    }
  }
`;

export const Tab = styled(Button)<{ active: boolean }>`
  color: ${props => (props.active ? props.theme.colors.primary : '#9ea0a1')};
  font-size: 14px;
  height: 55px;
  padding: 1px 7px;
  border: none;
  border-radius: 0;
  border-bottom: 2px solid ${props => (props.active ? props.theme.colors.primary : 'transparent')};
  background-color: transparent;

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.primary};
    background-color: transparent;
  }
`;
